import { MouseCursorIcon, TourScreensOutlineIcon } from '@carboncopyco/icons';
import type { TourFrame } from '@carboncopyco/types';
import { ColorHex, Spacer, TextBase, TextCaption } from '@carboncopyco/ui';
import classNames from 'classnames';

interface TourFrameCaptureItemProps {
  frameData: TourFrame;
  isLoading?: boolean;
  progress?: number;
}

export const TourFrameCaptureItem = ({
  frameData,
  isLoading,
  progress,
}: TourFrameCaptureItemProps) => {
  const { frameEventType, frameTitle, frameActionLabel } = frameData;

  return (
    <div
      className={classNames(
        'flex flex-1 min-w-0 items-center justify-start px-4 py-4 border border-ds-natural-150 rounded-md relative border-solid overflow-hidden'
      )}
    >
      <div className="flex flex-col">
        <div className="flex items-center w-ds-54 pb-1">
          <div>
            {frameEventType === 'click' ? (
              <MouseCursorIcon
                size={20}
                color={ColorHex.natural300}
              />
            ) : (
              <TourScreensOutlineIcon
                size={20}
                color={ColorHex.natural300}
              />
            )}
          </div>
          <Spacer amount={0.5} />
          <div className="flex">
            {frameEventType === 'click' && (
              <>
                <div>
                  <TextCaption
                    label={frameEventType === 'click' && 'Click:'}
                    color="text-ds-natural-300"
                  />
                </div>
                <Spacer amount={0.25} />
              </>
            )}
            <div
              className={classNames(
                'truncate text-ds-natural-300',
                frameEventType === 'click' ? 'w-40' : 'w-48'
              )}
            >
              <TextCaption
                label={`"${frameActionLabel}"`}
                color="text-ds-natural-300"
                ellipsis
              />
            </div>
          </div>
        </div>
        <div className={'w-ds-54 truncate'}>
          <TextBase
            label={isLoading ? 'Loading...' : frameTitle}
            color={'text-ds-natural-600'}
            ellipsis
          />
        </div>
      </div>
      {isLoading && !!progress && (
        <div
          className="absolute h-0.5 w-full bottom-0 left-0 bg-ds-natural-150"
          style={{
            height: '2px',
          }}
        >
          <div
            className="bg-ds-primary-300"
            style={{
              height: '2px',
              width: `${progress * 100}%`,
            }}
          />
        </div>
      )}
    </div>
  );
};
